// CustomTooltip.js
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  arrow: {
    fontSize: 35,
    color: "#",
    "&::before": {
      backgroundColor: "white",
      border: "2px solid white",
    },
  },
  tooltip: {
    color: "#0B0C0C",
    fontSize: "14px",
    fontFamily: "Roboto",
    fontWeight: "400",
    lineHeight: "20px",
    minWidth: "400px",
    padding: "20px",
    textAlign: "justify",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #E6E8ED",
    filter: "drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.2))",
    borderRadius: "15px",
  },
  popper: {
    display: "flex",
    alignItems: "flex-start", // Align arrow to the top
    // marginBottom: "-40px", // Adjust position if necessary
  },
}));

function CustomTooltip({ title, children }) {
  const classes = useStyles();

  return (
    <Tooltip
      title={title}
      arrow
      placement="right"
      classes={{
        arrow: classes.arrow,
        tooltip: classes.tooltip,
        popper: classes.popper,
      }}
    >
      {children}
    </Tooltip>
  );
}

export default CustomTooltip;
